(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambassador-template"]) return;
  try {
    
$('.join').magnificPopup({
	type:'inline',
	midClick: true
});
const scriptURL = 'https://script.google.com/macros/s/AKfycbwbsatCeA02e1iAHIgF5lLiXzsVArP20FN5RsgGPCyY8wva_5jcJXqJNhVqpwi0Wd_R_g/exec'
const form = document.forms['submit-to-google-sheet']

form.addEventListener('submit', e => {
	e.preventDefault()
	fetch(scriptURL, { method: 'POST', body: new FormData(form)}).then(response => { console.log('Success!', response); $('form').addClass('hide');$('.success').addClass('show');})
	.catch(error => { console.error('Error!', error.message); $('.error').addClass('show');})
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
setTimeout(function(){ 
  $(".final_checkout").attr("disabled", false).removeClass('isDisabled');
  console.log('Enabled the disable');
}, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart_template_hulkapps_backup"]) return;
  try {
    
setTimeout(function(){ 
  $(".final_checkout").attr("disabled", false).removeClass('isDisabled');
  console.log('Enabled the disable');
}, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
var count = $(".hero-link").length;
if (count > 1) {
	var $heroSlider = $(".hero-slider").flickity({
		fade: true,
		pageDots: true,
		prevNextButtons: false,
		autoPlay: 6000,
		pauseAutoPlayOnHover: false
	});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-reviews"] && !Shopify.designMode) return;
  try {
    
var count = $(".reviews-slide").length;

if (count > 1) {
	var $pdpSlider = $(".reviews-slider").flickity({
		cellSelector: '.reviews-slide',
		fade: true,
		pageDots: false,
		prevNextButtons: false,
		wrapAround: true,
		draggable: true,
		imagesLoaded: true
	});
	$(".button-row").removeClass("hide");
	// Flickity instance
	var flkty = $pdpSlider.data("flickity");
	// elements
	var $cellButtonGroup = $(".button-group--cells");
	var $cellButtons = $cellButtonGroup.find(".dot");
	// update selected cellButtons
	$pdpSlider.on("select.flickity", function () {
		$cellButtons.filter(".is-selected").removeClass("is-selected");
		$cellButtons.eq(flkty.selectedIndex).addClass("is-selected");
	});
	// select cell on button click
	$cellButtonGroup.on("click touch", ".dot", function () {
		var index = $(this).index();
		$pdpSlider.flickity("select", index);
	});
	// previous
	$(".button--previous").on("click", function () {
		$pdpSlider.flickity("previous");
	});
	// next
	$(".button--next").on("click", function () {
		$pdpSlider.flickity("next");
	});
} else {}

  } catch(e) { console.error(e); }
})();
})();
